module["exports"] = [
  "cz",
  "com",
  "net",
  "eu",
  "org"
];
